module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 732
// module chunks = 0